import Vue from "vue";
import Router from "vue-router";
import store from "@/core/services/store";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/mangrove_info",
      component: () => import("@/view/layout/Layout"),
      beforeEnter: (to, from, next) => {
        !store.state.auth.isAuthenticated
          ? next({
            name: "login"
          })
          : next();
      },
      children: [
       /*  {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Dashboard.vue")
        }, */
        {
          path: "/iot",
          name: "iot",
          component: () => import("@/components/iot/iot")
        },
        {
          path: "/video_streaming",
          name: "video_streaming",
          component: () => import("@/components/video_streaming/video_streaming")
        },


          ///--mangrove_map--
          {
            path: "/Point",
            name: "Point",
            component: () => import("@/components/points_could/PointsCouldTable")
          },

        {
          path: "/mangrove_info",
          name: "mangroveInfoTable",
          component: () => import("@/view/pages/mangrove_info/Table.vue")
        },
        {
          path: "/mangrove_info/form",
          name: "mangroveInfoFormCrate",
          component: () => import("@/view/pages/mangrove_info/Form.vue")
        },


        {
          path: "/mangrove_info/form/:id",
          name: "mangroveInfoFormUpdate",
          component: () => import("@/view/pages/mangrove_info/Form.vue")
        },






        ///--user manage--


        // --user--
        {
          path: "/user",
          name: "userTable",
          component: () => import("@/view/pages/user/Table.vue")
        },
        {
          path: "/user/form/create",
          name: "FormCreate",
          component: () => import("@/view/pages/user/FormCreate.vue")
        },
        {
          path: "/user/form/:id",
          name: "userFormUpdate",
          component: () => import("@/view/pages/user/Form.vue")
        },

        //profile
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/view/pages/profile/Profile.vue")
        }
      ]
    },
    {
      path: "/custom-error",
      name: "error",
      component: () => import("@/view/pages/error/Error.vue"),
      children: [
        {
          path: "error-1",
          name: "error-1",
          component: () => import("@/view/pages/error/Error-1.vue")
        },
        {
          path: "error-2",
          name: "error-2",
          component: () => import("@/view/pages/error/Error-2.vue")
        },
        {
          path: "error-3",
          name: "error-3",
          component: () => import("@/view/pages/error/Error-3.vue")
        },
        {
          path: "error-4",
          name: "error-4",
          component: () => import("@/view/pages/error/Error-4.vue")
        },
        {
          path: "error-5",
          name: "error-5",
          component: () => import("@/view/pages/error/Error-5.vue")
        },
        {
          path: "error-6",
          name: "error-6",
          component: () => import("@/view/pages/error/Error-6.vue")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/view/pages/login/Login"),
      beforeEnter: (to, from, next) => {
        store.state.auth.isAuthenticated
          ? next({
            name: "mangrove_info"
          })
          : next();
      },
      children: [
        {
          name: "login",
          path: "/login",
          component: () => import("@/view/pages/login/Login")
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-1.vue")
    }
  ]
});
